import React, { Component } from 'react'
import SessionActions from '../actions/SessionActions'
import SessionStore from '../stores/SessionStore'
import UserActions from '../actions/UserActions'
import UserStore from '../stores/UserStore'
import ReactCaptcha from '../components/captcha/ReactCaptcha';
import { Form, Image, Button, Overlay, Popover } from 'react-bootstrap'
import { Link } from 'react-router'
import '../styles/Login.css'
import FaceAPI from '../apis/FaceAPI'
import GoogleLogin from './GoogleLogin'
import HandleException from '../utils/HandleException'
import ErrorStore from '../stores/ErrorStore'
import VersionStore from '../stores/VersionStore'
import VersionActions from '../actions/VersionActions'
import LogoImg from './LogoImg'

const passwordMsg = 'password is required (minimum is 6 characters).'
const emailRequired = 'email is required.'
const captchaFailed = 'captcha verification failed.'
const clientId = process.env.GOOGLE_CLIENTID

export default class Signup extends Component {
  constructor(props) {
    super(props)
    this.emailRef = target => this.setState({ emailState: target })
    this.passwordRef = target => this.setState({ passwordState: target })
    this.captchaRef = target => this.setState({ captchaState: target })
    this.state = {
      email: '',
      password: '',
      isLoading: false,
      validationMessage: {}
    }
    this.onNew = this.onNew.bind(this)
    this.onFeedback = this.onFeedback.bind(this)
    this.validateForm = this.validateForm.bind(this)
    this.handleChangePassword = this.handleChangePassword.bind(this)
    this.handleChangeEmail = this.handleChangeEmail.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.onLogin = this.onLogin.bind(this)
    this.onLoginFacebook = this.onLoginFacebook.bind(this)
    this.redirectToContents = this.redirectToContents.bind(this)
    this.onError = this.onError.bind(this)
    this.container = React.createRef()
    this.componentId = 'signup'
    this.onChangeVersion = this.onChangeVersion.bind(this)
    this.handleSuccess = this.handleSuccess.bind(this)
    this.handleFailure = this.handleFailure.bind(this)
    this.captchaMatched = false;
  }

  componentDidMount() {
    VersionActions.receiveVersion();
  }

  UNSAFE_componentWillMount() {
    UserStore.addNewListener(this.onNew)
    UserStore.addFeedbackListener(this.onFeedback)
    SessionStore.addLoginListener(this.onLogin)
    ErrorStore.addErrorListener(this.onError)
    VersionStore.addChangeListener(this.onChangeVersion)
  }

  componentWillUnmount() {
    UserStore.removeNewListener(this.onNew)
    UserStore.removeFeedbackListener(this.onFeedback)
    SessionStore.removeLoginListener(this.onLogin)
    ErrorStore.removeErrorListener(this.onError)
    VersionStore.removeChangeListener(this.onChangeVersion)
  }

  onFeedback() {
    var feedback = UserStore.getFeedback()
    if (feedback.hasOwnProperty('email') ||
      feedback.hasOwnProperty('password')) {
      var val = this.state.validationMessage
      val['email'] = feedback['email']
      val['password'] = feedback['password']
      this.setState({ validationMessage: val })
    } else {
      var message = feedback.hasOwnProperty('description') ? feedback.description : feedback
      alert(message)
    }
  }

  onNew() {
    SessionActions.saveSession(this.componentId, this.state)
  }

  validateForm() {
    this.setMsg('email', '')
    this.setMsg('password', '')
    this.setMsg('captcha', '')
    if (this.state.email.length == 0) this.setMsg('email', emailRequired)
    if (this.state.password.length < 6) this.setMsg('password', passwordMsg)
    if (this.captchaMatched == false) this.setMsg('captcha', captchaFailed)
    return (this.state.validationMessage['email'] === '' && this.state.password.length > 5 && this.captchaMatched != false)
  }

  setMsg(field, msg) {
    var val = this.state.validationMessage
    val[field] = msg
    this.setState({ validationMessage: val })
  }

  handleChangeEmail(event) {
    this.setState({ [event.target.id]: event.target.value })
    event.target.value.length == 0 ? this.setMsg('email', emailRequired) : UserActions.verifyEmail(this.componentId, event.target.value)
  }

  handleChangePassword(event) {
    this.setState({ [event.target.id]: event.target.value })
    event.target.value.length < 6 ? this.setMsg('password', passwordMsg) : this.setMsg('password', '')
  }

  handleSubmit(event) {
    event.preventDefault()
    if (this.validateForm()) {
      this.setState({ isLoading: true })
      UserActions.saveUser(this.componentId, this.state)
    }
  }

  onLoginFacebook() {
    FaceAPI.init()
      .then(
        FaceAPI.checkLoginState,
        error => { throw error }
      )
      .then(
        response => {
          if (response.status === 'connected') {
            return FaceAPI.removePermissions().then(
              () => {
                return FaceAPI.logout
              },
              error => { throw error }
            ).then(
              () => {
                return FaceAPI.login({ scope: 'email', auth_type: 'rerequest' })
              },
              error => { throw error }
            )
          } else if (response.status === 'not_authorized') {
            return FaceAPI.login({ scope: 'email', auth_type: 'reauthorize' })
          } else {
            return FaceAPI.login({ scope: 'email', auth_type: 'reauthenticate' })
          }
        },
        error => { throw error }
      )
      .then(
        FaceAPI.fetch,
        error => { throw error }
      )
      .then(
        response => {
          if (!response['email']) {
            FaceAPI.logout()
            throw 'invalid email'
          }
          console.log('connected as ' + response['name'])
          UserActions.saveSocialUser(this.componentId, response['email'], 'facebook')
        },
        error => { throw error }
      )
      .catch((error) => {
        console.warn(error)
      })
  }

  onLoginGoogle(response) {
    UserActions.saveSocialUser(this.componentId, response['profileObj']['email'], 'google')
  }

  errorGoogle(response) {
    console.error(response)
  }

  onLogin() {
    this.redirectToContents()
  }

  redirectToContents() {
    if (SessionStore.getLogged()) {
      this.props.route.history.push({ pathname: 'contents' });
    }
  }

  onError(source, error) {
    if (source == this.componentId) {
      HandleException.handle_error(error);
    }
  }

  onChangeVersion() {
    window.location.reload(true)
  }

  handleSuccess = () => {
    this.captchaMatched = true
  }

  handleFailure = () => {
    this.captchaMatched = false
  }

  render() {
    return (
      <div className='signup-form' ref={this.container}>
        <div className='Login text-center'>
          <div className='card'>
            <LogoImg />
            <div className='signal34-explore'>
              Explore, collect and access <br />
              your best content from anywhere <br />
              with a Signal34 account! <br />
            </div>
            <div className='center-text-signup' />
            <Form onSubmit={this.handleSubmit} className='signal34-form'>
              <Form.Group controlId='email'>
                <Form.Control autoFocus type='email' value={this.state.email} onChange={this.handleChangeEmail} placeholder='Email' ref={this.emailRef} autoComplete='username' />
                <Overlay show={this.state.validationMessage['email'] !== undefined && this.state.validationMessage['email'] !== ''} target={this.state.emailState} placement='right' container={() => this.container.current} containerPadding={20} >
                  <Popover id='popover-email'>
                    <Popover.Body>
                      {this.state.validationMessage['email']}
                    </Popover.Body>
                  </Popover>
                </Overlay>
              </Form.Group>

              <Form.Group controlId='password'>
                <Form.Control value={this.state.password} onChange={this.handleChangePassword} type='password' placeholder='Create a password' ref={this.passwordRef} autoComplete='new-password' />
                <Overlay show={this.state.validationMessage['password'] !== undefined && this.state.validationMessage['password'] !== ''} target={this.state.passwordState} placement='right' container={() => this.container.current} containerPadding={20} >
                  <Popover id='popover-password' >
                    <Popover.Body>
                      {this.state.validationMessage['password']}
                    </Popover.Body>
                  </Popover>
                </Overlay>
              </Form.Group>

              <div className='signal34-recaptcha' ref={this.captchaRef}>
                <ReactCaptcha charset='ul' length={5} color='#5a5a5a' reload handleSuccess={this.handleSuccess} handleFailure={this.handleFailure} />
                <Overlay show={this.state.validationMessage['captcha'] !== undefined && this.state.validationMessage['captcha'] !== ''} target={this.state.captchaState} placement='right' container={() => this.container.current} containerPadding={20} >
                  <Popover id='popover-captcha' >
                    <Popover.Body>
                      {this.state.validationMessage['captcha']}
                    </Popover.Body>
                  </Popover>
                </Overlay>
              </div>
              <div className='signal34-blue-button'>
                <Button className="signal34-bnt-primary" variant="primary" type='submit'>Continue</Button>
              </div>
              <div className='signal34-or'>
                OR
              </div>
              <div>
                <div className='signal34-facebook' onClick={this.onLoginFacebook}>
                  <span className="svg-container">
                    <Image src='data:image/svg+xml;utf8,<svg enable-background="new 0 0 128 128" height="24px" id="Layer_1" version="1.1" viewBox="0 0 128 128" width="24px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><rect fill="%23FFFFFF" height="128" width="128"/></g><path d="M68.877,128V78.188h-17.78V60.425h17.784V44.029c0-16.537,9.764-26.279,24.514-26.279  c7.068,0,12.834,0.756,14.605,0.991v18.573l-11.874-0.005c-8.022,0-9.523,3.979-9.523,9.572v13.544h20.556l-2.904,17.763H86.603V128  H68.877z" fill="%233C579E"/></svg>' />
                  </span>
                  <span>Continue with Facebook</span>
                </div>
                <GoogleLogin clientId={clientId} onSuccess={this.onLoginGoogle} onFailure={this.errorGoogle} buttonText='Continue with Google' offline={false} prompt={'select_account'} className='signal34-google' />
              </div>
            </Form>

            <div className='signal34-continuing'>
              By continuing you agree to Signal34&#39;s <span><a target='_blank' href='./personal_terms_of_service'>Terms of</a></span>
            </div>
            <div className='signal34-continuing'>
              <span><a target='_blank' href='./personal_terms_of_service'>Service</a></span> and <span><a target='_blank' href='./privacy_policy'>Privacy policy</a></span>
            </div>
            <div className='signal34-already'>
              <span><Link to={'/'}>Already a member? Log in</Link></span>
            </div>
            <div className='signal34-middle-bold create-business' >
              <Link to={'/signup_business'}><span>Create a business account </span></Link>
            </div>
          </div>
        </div>
        <footer>
          <div className='text-center small copyright signal34-footer'>
            <div>
              <span> © 2019 Signal34 </span> | <a target='_blank' href='./about'>About</a> | <Link to={'/'}>Home</Link> | <Link to={'/signup'}>Sign Up</Link> | <a target='_blank' href='./howto'>HowTo</a> | <a target='_blank' href='./personal_terms_of_service'>Terms of Service</a> | <a target='_blank' href='./privacy_policy'>Privacy policy</a>
            </div>
          </div>
        </footer>
      </div>
    )
  }
}
